module.exports = __webpack_public_path__ + "img/PizzaMachtGlücklich.6363706f.svg";